import { RootState } from "integrations/redux"
import { pilotTrackingSliceName } from "./slice"

const root = (state: RootState) => state[pilotTrackingSliceName]

export const selectSelectedAircraftIds = (state: RootState) => root(state).selected.aircraftIds
